import { defaultError } from '@qpr/client-library';
import api, { ApiRequest, ApiResult } from '../../api/api-caller';
import initialState, { QprThemeProviderState } from './qpr-theme-provider-state';

interface CacheData {
  [key: string]: any;
}

const errorHandler = (apiResult: ApiResult): QprThemeProviderState => {
  return {
    ...initialState,
    error: apiResult.error || defaultError
  };
};

const getThemeFromAPI = async (tenantSymbol: string, themeName: string): Promise<ApiResult> => {
  const req: ApiRequest = {
    method: 'GET'
  };
  const result: ApiResult = await api.asyncCallApi(
    `themes?symbol=${tenantSymbol}&name=${themeName}`,
    req
  );
  return result;
};

const viewModelCache: CacheData = {};

export interface QprThemeProviderViewModelType {
  getData(): Promise<QprThemeProviderState>;
}

const createViewModel = (tenantSymbol: string, themeName: string = '') => {
  let themeResponse: ApiResult;

  const fetchTheme = async (): Promise<ApiResult> => {
    const cacheKey: string = '';

    if (viewModelCache[cacheKey]) {
      console.log('From cache', viewModelCache[cacheKey]);
      themeResponse = viewModelCache[cacheKey];
    } else {
      themeResponse = await getThemeFromAPI(tenantSymbol, themeName);

      viewModelCache[cacheKey] = themeResponse;
    }
    return themeResponse;
  };

  const getData = async (): Promise<QprThemeProviderState> => {
    if (!themeResponse) {
      try {
        themeResponse = await fetchTheme();
        if (!themeResponse.ok) return errorHandler(themeResponse);
      } catch (error) {
        return {
          ...initialState,
          error: { message: 'Something went wrong', details: JSON.stringify(error) }
        };
      }
    }
    return {
      ...initialState,
      themes: themeResponse.data
    };
  };

  return { getData };
};

export default createViewModel;
